import React from 'react';

import { Grid, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

import EditorialBand from '../../components/public/EditorialBand.component';
import EditorialHero from '../../components/public/EditorialHero.component';
import EditorialProcess from '../../components/public/EditorialProcess.component';
import OfferCard from '../../components/public/OfferCard.component';
import {
  ENTERPRISE_OFFERS,
  ENTERPRISE_OFFER_HERO,
} from '../../constants/enterprise-offer-content.constants';
import Meta from '../../../utils/metaDescription';

const useStyles = makeStyles((theme) => ({
  sectionTitle: {
    fontFamily: 'Bitter, serif',
    fontWeight: 700,
    fontSize: 'clamp(1.5rem, 4vw, 2.1rem)',
    lineHeight: 1.2,
    marginBottom: '2rem',
    textAlign: 'center',
    color: theme.palette.client.primary.extraDark,
  },
  processTitle: {
    fontFamily: 'Bitter, serif',
    fontWeight: 700,
    fontSize: 'clamp(1.15rem, 3vw, 1.4rem)',
    lineHeight: 1.25,
    marginBottom: '1.25rem',
    color: theme.palette.client.primary.extraDark,
  },
}));

const EnterpriseOfferView: React.FC = () => {
  const classes = useStyles();

  return (
    <React.Fragment>
      <Meta page="entreprises" />

      <EditorialBand ground="cream" underFloatingNav>
        <EditorialHero title={ENTERPRISE_OFFER_HERO.title} lead={ENTERPRISE_OFFER_HERO.lead} />
      </EditorialBand>

      {/* Les deux offres côte à côte, mêmes critères dans le même ordre : le visiteur se reconnaît
          à la taille de son entreprise sans avoir à faire d'aller-retour dans la page. */}
      <EditorialBand ground="plain">
        <Grid container spacing={3} alignItems="stretch">
          {ENTERPRISE_OFFERS.map((offer) => (
            <Grid item xs={12} md={6} key={offer.title}>
              <OfferCard offer={offer} />
            </Grid>
          ))}
        </Grid>
      </EditorialBand>

      <EditorialBand ground="tint">
        <Typography component="h2" className={classes.sectionTitle}>
          Comment ça se passe
        </Typography>

        <Grid container spacing={3} alignItems="flex-start">
          {ENTERPRISE_OFFERS.map((offer) => (
            <Grid item xs={12} md={6} key={offer.processTitle}>
              <Typography component="h3" className={classes.processTitle}>
                {offer.processTitle}
              </Typography>
              <EditorialProcess steps={offer.processSteps} />
            </Grid>
          ))}
        </Grid>
      </EditorialBand>
    </React.Fragment>
  );
};

export default EnterpriseOfferView;
